import { buildListSearch, parseListPage } from "./listQueryParams";

export const ALL_PHARMACIES_RETURNS_PATH = "/admin/all/pharmacies/returns";

export type ReturnRequestsListQuery = {
  page: number;
  searchValue: string;
  status: string;
  serviceType: string;
  startDate: string;
  endDate: string;
};

export const DEFAULT_RETURN_REQUESTS_LIST_QUERY: ReturnRequestsListQuery = {
  page: 0,
  searchValue: "",
  status: "",
  serviceType: "",
  startDate: "",
  endDate: "",
};

export const parseReturnRequestsListQuery = (
  search: string
): ReturnRequestsListQuery => {
  const params = new URLSearchParams(search);
  return {
    page: parseListPage(params.get("page")),
    searchValue: params.get("searchValue") ?? "",
    status: params.get("status") ?? "",
    serviceType: params.get("serviceType") ?? "",
    startDate: params.get("startDate") ?? "",
    endDate: params.get("endDate") ?? "",
  };
};

export const buildReturnRequestsListSearch = (
  query: ReturnRequestsListQuery
): string => buildListSearch(query);

export const isAllPharmaciesReturnsUrl = (url?: string): boolean => {
  if (!url) {
    return false;
  }
  return (
    url === ALL_PHARMACIES_RETURNS_PATH ||
    url.startsWith(`${ALL_PHARMACIES_RETURNS_PATH}?`)
  );
};
